export default __webpack_public_path__ + "a2daa74.png";